export default __webpack_public_path__ + "static/media/react-bootstrap-carousel.96e06938.woff";